import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/acumulados-nominas-columnas';

/**
 * GET Acumulados Nóminas Columnas (Configurador de Nóminas Acumuladas)
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getAcumuladosNominasColumnas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Acumulado Nómina Columna
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getAcumuladoNominaColumna = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Acumulado Nómina Columna
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postAcumuladoNominaColumna = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values, { clean: false }));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Acumulado Nómina Columna
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchAcumuladoNominaColumna = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, getFormattedValues(values, { clean: false }));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Acumulado Nómina Columna
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteAcumuladoNominaColumna = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * Descarga el Excel de Nóminas Acumuladas del ejercicio, armado en el servidor
 * a partir del configurador. Devuelve `{ blob, error }`.
 * @param {number} ejercicio
 * @returns {Promise<{blob: Blob|null, error: string|null}>}
 */
export const descargarExcelNominasAcumuladas = async (ejercicio) => {
  try {
    const response = await API.get(`${baseURI}/descargar-excel/`, {
      params: { ejercicio },
      responseType: 'blob',
    });
    return { blob: response.data, error: null };
  } catch (err) {
    let detail = 'No se pudo generar el Excel.';
    const errData = err?.response?.data;
    if (errData instanceof Blob) {
      try {
        const body = JSON.parse(await errData.text());
        detail = body?.ejercicio?.[0] || body?.detail || detail;
      } catch {
        // Se mantiene el mensaje genérico si el cuerpo del error no es JSON.
      }
    }
    return { blob: null, error: detail };
  }
};
